import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from 'react-router-dom';

export default function NavigateBack({ slug }) {
    return (
        <Tooltip title="Back" aria-label="back">
            <IconButton color="primary" variant='contained' aria-label="menu" component={Link} to={slug}>
                <ArrowBackIcon />
            </IconButton>
        </Tooltip>
    )
}
